import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import PageHero from '../components/PageHero';
import { services, clinicInteriorImage } from '../mock';

const ServicesPage = () => {
  return (
    <div className="App bg-white">
      <Header />
      <PageHero
        eyebrow="What we do"
        title="Care built around"
        italic="how you move."
        description="From acute injury to long-term performance, we combine hands-on treatment, active exercise, and clear education so every patient understands their plan."
        image={clinicInteriorImage}
        breadcrumbs={[{ label: 'Home', to: '/' }, { label: 'Services' }]}
      />

      <section className="py-16 lg:py-24">
        <div className="max-w-[1240px] mx-auto px-6 grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((s) => {
            const Ic = s.icon;
            return (
              <Link
                key={s.slug}
                to={`/services/${s.slug}`}
                className="group relative rounded-[24px] border border-neutral-200 bg-white hover:border-[#CA0028] transition-all duration-300 p-7 overflow-hidden"
              >
                <div className="flex items-start justify-between">
                  <span className="w-12 h-12 rounded-2xl bg-neutral-100 grid place-items-center group-hover:bg-[#CA0028] group-hover:text-white transition-colors">
                    <Ic size={20} />
                  </span>
                  <ArrowUpRight size={20} className="text-neutral-400 group-hover:text-neutral-900 group-hover:-translate-y-0.5 group-hover:translate-x-0.5 transition-all" />
                </div>
                <h3 className="mt-6 text-[22px] font-semibold text-neutral-900 tracking-tight">{s.name}</h3>
                <p className="mt-2 text-[14px] text-[#CA0028] font-medium">{s.tagline}</p>
                <p className="mt-4 text-[14px] leading-relaxed text-neutral-600">{s.short}</p>
              </Link>
            );
          })}
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ServicesPage;
